import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import Icon from "../common/Icon";
import "./ChartModal.css";

const ChartModal = ({ isOpen, onClose, title, className = "", children }) => {
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const contentClassName = `chart-modal-content ${className}`.trim();

  return createPortal(
    <div className="chart-modal-overlay" onClick={handleBackdropClick}>
      <div className={contentClassName}>
        <div className="chart-modal-header">
          <h2 className="chart-modal-title">{title}</h2>
          <button
            className="chart-modal-close-button"
            onClick={onClose}
            aria-label="Fermer"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="chart-modal-body">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default ChartModal;
